/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import ReactPlayer from 'react-player'

// GET PARAMS FROM URL
const params = new URL(window.location).searchParams
const lang = params.get('lang')

const trailerMP4 = require('../../videos/front_embed_trailer.mp4')

const trailerWebm = require('../../videos/front_embed_trailer.webm')

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      {/* see here https://github.com/CookPete/react-player/blob/master/src/demo/App.js */}
      <ReactPlayer
        className='react-player'
        width='100%'
        height='100%'
        url={[
          {
            src: trailerMP4,
            type: 'video/mp4'
          },
          {
            src: trailerWebm,
            type: 'video/webm'
          }
        ]}
        playing // {this.props.autoPlay ? true : false}
        playsinline // {!this.isIOS}
        controls
        muted
        loop
        /*
           onEnded={this.handleEnded}
           pip={pip}
           playing={playing}
           controls={controls}
           light={light}
           loop={loop}
           playbackRate={playbackRate}
           volume={volume}
           muted={muted}
           onReady={() => console.log('onReady')}
           onStart={() => console.log('onStart')}
           
           onEnablePIP={this.handleEnablePIP}
           onDisablePIP={this.handleDisablePIP}
           onPause={this.handlePause}
           onBuffer={() => console.log('onBuffer')}
           onSeek={e => console.log('onSeek', e)}
           onEnded={this.handleEnded}
           onError={e => console.log('onError', e)}
           onProgress={this.handleProgress}
           onDuration={this.handleDuration}
           */
      />
    </div>
  )
}
